import React, { useContext } from 'react';

import { ConfigContext } from 'Context/config';

import { AffiliateType } from 'Storybook/components/local/LogoAffiliate/LogoAffiliate.helpers';

import { AffiliateHeader } from './AffiliateHeader';

export const AffiliateHeaderContainer = React.memo(() => {
  const { configState: { affiliate } } = useContext(ConfigContext);

  return (
    <>
      {
        (affiliate?.showBranding)
          ? (<AffiliateHeader affiliate={affiliate.slug as AffiliateType} />)
          : (null)
      }
    </>
  );
}, () => true);
